import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RadioGroup } from 'components/UI/V3/Forms/RadioGroup';
import { FunctionComponent } from 'react';
import { CONFLICT_PREFERENCE_LABELS, ConflictPreference } from 'model/RecurringSeries';
import StepSection from './StepSection';
import styles from './RecurringSeriesSteps.module.scss';

interface ConflictsStepProps {
    conflicts: ConflictPreference;
    onChangeConflicts: (conflicts: ConflictPreference) => void;
}

const CONFLICT_PREFERENCES: Array<ConflictPreference> = ['create_anyway', 'next_available', 'do_not_create'];

const options = CONFLICT_PREFERENCES.map(value => ({ value, inlineLabel: CONFLICT_PREFERENCE_LABELS[value] }));

export const ConflictsStep: FunctionComponent<ConflictsStepProps> = props => (
    <StepSection
        number={3}
        title="Conflicts"
    >
        <RadioGroup<ConflictPreference>
            options={options}
            value={props.conflicts}
            className={styles.conflictsRow}
            onChange={props.onChangeConflicts}
        />

        <div className={styles.note}>
            <FontAwesomeIcon
                icon={faInfoCircle}
                className={styles.noteIcon}
            />
            <p className={styles.noteText}>
                Availability, staff schedule, and business closures will be checked when the series is created. Results
                may vary based on conflicts
            </p>
        </div>
    </StepSection>
);

export default ConflictsStep;
